var _text;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaginationDotIconMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "\\u2026",
    transform: "translate(0 20)",
    fill: "#646464",
    fontSize: 20,
    fontFamily: "'J\\\\\\\\&JCircularTT-Bold', 'J\\\\\\\\&J CircularTT'",
    fontWeight: 700,
    letterSpacing: "0.001em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2026"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationDotIconMobile);
export default __webpack_public_path__ + "static/media/paginationDotIcon-mobile.64a04bd494d24eb60196f17ef5e3caaa.svg";
export { ForwardRef as ReactComponent };